<template>
  <div>
    <div class="accounts-section-wrapper content-wrapper">
      <progress-bar :currentStep="3"></progress-bar>
      <div class="header-request">
        <h3>{{ request.message }}</h3>
      </div>
      <form
        class="accounts-wrapper"
        id="accounts-form"
        @submit.prevent="sendAccountInstruction"
      >
        <div
          v-for="(value, key) in accounts"
          :key="key"
          class="account-item"
          :class="{ selected: selectedAccount === key }"
          @click="selectAccount(key)"
        >
          <div class="acc-info-wrapper">
            <div
              class="acc-name"
              :class="
                getAccountNumber(value) || getAccountBalance(value)
                  ? ''
                  : 'last-item'
              "
              v-if="getAccountName(value)"
            >
              <div class="label">Account Name</div>
              <div class="value">{{ getAccountName(value) }}</div>
            </div>

            <div
              class="acc-number"
              :class="
                getAccountBalance(value) && isShowBalance ? '' : 'last-item'
              "
              v-if="getAccountNumber(value)"
            >
              <div class="label">Account Number</div>
              <div class="value">{{ getAccountNumber(value) }}</div>
            </div>

            <div
              class="acc-balance"
              v-if="getAccountBalance(value) && isShowBalance"
            >
              <div class="label">Balance</div>
              <div class="value">{{ getAccountBalance(value) }}</div>
            </div>
          </div>
        </div>

        <proceed-button
          v-if="!this.$isMobile()"
          :is-proceed-enable="!!selectedAccount"
          :is-loading="isLoading"
        />
      </form>
    </div>

    <!-- Mobile layout proceed button -->
    <div
      v-if="this.$isMobile()"
      class="proceed-btn-sticky-wrapper"
      ref="prcbtn"
    >
      <proceed-button
        form="accounts-form"
        :is-proceed-enable="!!selectedAccount"
        :is-loading="isLoading"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ProgressBar from '@/components/ProgressBar'
import ProceedButton from '@/components/buttons/ProceedButton'
import Constants from '@/constants'
import { blockBackNavigationMixin } from '@/mixins/blockBackNavigationMixin'

export default {
  name: 'Accounts',
  components: {
    ProgressBar,
    ProceedButton,
  },
  mixins: [blockBackNavigationMixin],

  props: {
    request: {
      type: Object,
      default: () => {
        // Default value thats populated with the request being sent from backend
      },
    },
  },

  beforeRouteLeave(to, from, next) {
    const { name } = to
    if (name !== 'progressLoading') {
      next(false)
    }

    next()
  },

  data() {
    return {
      selectedAccount: null,
      isLoading: false,
      isShowBalance: Constants.isShowBalance,
      observer: null,
    }
  },

  computed: {
    ...mapState('transaction', ['transaction']),
    ...mapGetters('merchantSettings', ['banksList']),

    transactionId() {
      return this.$route.query.transactionId
    },

    accounts() {
      return this.request.options
    },

    bank() {
      return this.banksList.find(
        (item) => item.acquirerCode === this.transaction.acquirerCode
      )
    },
  },

  mounted() {
    this.selectAccount(Object.keys(this.accounts)[0])
  },

  methods: {
    getAccountName(accountSting) {
      const parts = accountSting.split('-')
      return parts[0] && parts[0].trim()
    },
    getAccountNumber(accountSting) {
      const parts = accountSting.split('-')
      return parts[1] && parts[1].trim()
    },
    getAccountBalance(accountSting) {
      const parts = accountSting.split('-')
      return parts[2] && parts[2].trim()
    },
    selectAccount(account) {
      this.selectedAccount = account
    },
    sendAccountInstruction() {
      if (!this.selectedAccount) {
        return
      }
      this.isLoading = true
      this.$logInfo({
        transactionId: this.transactionId,
        message: Constants.logMessages.selectedAccount,
      })
      const instruction = {
        Account: this.selectedAccount,
      }

      this.$emit('send-response', {
        messageId: this.request.messageId,
        instruction,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.proceed-btn-sticky-wrapper {
  height: 138px;
  width: 100%;
  background-color: #fff;
  position: sticky;
  bottom: 0;
  padding: 0 20px;
  display: grid;
  place-items: center;

  & button {
    margin: 0;
    width: 90%;
    top: -25px;
  }
}

.accounts-section-wrapper {
  display: grid;
  place-items: center;
  height: 80%;
  padding: 0 20px 20px 20px;
}

.accounts-wrapper {
  display: grid;
  place-items: center;
  margin-bottom: 100px;

  @media screen and (max-width: $mobile-resolution) {
    width: 90%;
    padding: 0;
    margin-bottom: 0;
  }
}

.acc-info-wrapper {
  display: flex;
  flex-direction: row;

  @media screen and (max-width: $mobile-resolution) {
    flex-direction: column;
  }
}

.account-item {
  padding: 10px 36px 10px 14px;
  box-shadow: 0px 5px 15px rgba(166, 166, 166, 0.3);
  border-radius: 8px;
  width: 100%;
  margin: 8px auto;
  border: 2px solid transparent;
  display: flex;
  align-items: center;

  &.selected {
    border: 2px solid #fcc700;
  }
}

.acc-name,
.acc-number {
  margin-bottom: 0;

  @media screen and (max-width: $mobile-resolution) {
    margin-bottom: 10px;
  }
}

.acc-name + .acc-number,
.acc-number + .acc-balance,
.acc-name + .acc-balance {
  margin-left: 40px;

  @media screen and (max-width: $mobile-resolution) {
    margin-left: 0;
  }
}

.label {
  font-size: 10px;
  line-height: 12px;
  padding-bottom: 2px;
}

.value {
  font-size: 14px;
  line-height: 17px;
  font-weight: bold;
  letter-spacing: 1.5px;
}

.last-item {
  margin-bottom: 0;
}
</style>
